import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PermissionService } from "../permission.service";

@Injectable({
  providedIn: "root",
})
export class BroadcastListGuard implements CanActivate {
  constructor(
    private PermissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(this.PermissionService.categories.broadcasts.hasList()).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}

@Injectable({
  providedIn: "root",
})
export class BroadcastWriteGuard implements CanActivate {
  constructor(
    private PermissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(this.PermissionService.categories.broadcasts.hasWrite()).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}

@Injectable({
  providedIn: "root",
})
export class BroadcastDetailGuard implements CanActivate {
  constructor(
    private PermissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(this.PermissionService.categories.broadcasts.hasDetail()).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}
